var cilLevelDown = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='171.313 348.686 148.687 371.314 272 494.627 395.313 371.314 372.687 348.686 288 433.373 288 96 72 96 72 128 256 128 256 433.373 171.313 348.686' class='ci-primary'/>"];

export { cilLevelDown };

